import { useEffect, useRef, useState } from 'react';
import './HireMeCursor.css';

const ACTIVE_SECTIONS = ['home', 'skills'];

export default function HireMeCursor() {
  const cursorRef = useRef(null);
  const pos = useRef({ x: -200, y: -200 });
  const current = useRef({ x: -200, y: -200 });
  const rafId = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onMove = (e) => {
      pos.current = { x: e.clientX, y: e.clientY };

      // check if cursor is inside one of the active sections
      const el = document.elementFromPoint(e.clientX, e.clientY);
      const section = el?.closest('section');
      const inActiveSection = section
        ? ACTIVE_SECTIONS.includes(section.id)
        : false;
      setVisible(inActiveSection);
    };

    const animate = () => {
      current.current.x += (pos.current.x - current.current.x) * 0.12;
      current.current.y += (pos.current.y - current.current.y) * 0.12;

      if (cursorRef.current) {
        cursorRef.current.style.transform =
          `translate(${current.current.x}px, ${current.current.y}px)`;
      }
      rafId.current = requestAnimationFrame(animate);
    };

    window.addEventListener('mousemove', onMove);
    rafId.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(rafId.current);
    };
  }, []);

  return (
    <div
      className={`hire-cursor${visible ? ' hire-cursor--visible' : ''}`}
      ref={cursorRef}
    >
      HIRE ME
    </div>
  );
}
